import { ChangeEvent } from "react";
import { i18nService } from "services";
import {
  IToolFacet,
  IFieldType,
  IFormSchema,
  ActiveToolFacetType,
  ToolFacetType,
} from "types";

export const makeSchema = (
  facets: IToolFacet[],
  handleChangeTerm: (term: string) => void,
  handleChangeFacet: (facet: ActiveToolFacetType) => void
): IFormSchema => ({
  fields: [
    {
      name: ToolFacetType.term,
      label: i18nService.copy["toolSearch.keyword"],
      placeholder: i18nService.copy["toolSearch.keywordPlaceholder"],
      type: IFieldType.text,
      onChange: (e: ChangeEvent<HTMLInputElement>) =>
        handleChangeTerm(e.target.value),
    },
    ...facets.map(({ key, slug, options, ...rest }) => ({
      ...rest,
      name: key,
      type: IFieldType.checkboxGroup,
      onChange: (value: string[]) => {
        handleChangeFacet({
          [slug]: value,
        });
      },
      options: options.map((option) => ({
        type: IFieldType.checkbox,
        name: option.id,
        label: option.label,
        value: option.id,
      })),
    })),
  ],
});
